import React from 'react';
import UserInfo from '../UserInfo';
import { Button, ThemeProvider, Tooltip } from '@alphonsocode/kallos';
import logo from '../../animationAssets/adsurefinallogo.png';
import { MdLiveTv } from 'react-icons/md';
import UserGuideLauncher from 'features/userGuide/components/UserGuideLauncher';

const Header = () => {
  return (
    // @ts-ignore - ThemeProvider children type issue with React 18
    <ThemeProvider defaultMode="light">
      <div
        className="container-fluid position-relative d-flex justify-content-between align-items-center w-100"
        style={{ height: '100%' }}
      >
        <div className="d-flex align-items-center" style={{ gap: '16px' }}>
          <a href="/creative-preview" className="d-flex align-items-center">
            <img src={logo} alt="Logo" style={{ height: '55px' }} />
          </a>
        </div>

        <div
          className="d-flex align-items-center"
          style={{ gap: '16px', flexShrink: 0 }}
        >
          <Tooltip
            overlay="Back To TV Lab"
            openDelay={0}
            closeDelay={0}
            arrow={false}
            style={{
              maxWidth: '300px',
              whiteSpace: 'normal',
              wordBreak: 'break-word',
              marginTop: 5,
            }}
          >
            <Button
              variant="borderless"
              onClick={() => {
                const baseUrl = window.location.origin;
                const newUrl = `${baseUrl}`;
                window.location.href = newUrl;
              }}
              style={{
                width: '40px',
                height: '40px',
                borderRadius: '50%',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                backgroundColor: '#006e7d',
                color: '#fff',
              }}
            >
              <MdLiveTv size={20} />
            </Button>
          </Tooltip>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '16px',
              flexShrink: 0,
              whiteSpace: 'nowrap',
            }}
          >
            <UserGuideLauncher />
            <UserInfo />
          </div>
        </div>
      </div>
    </ThemeProvider>
  );
};

export default Header;
